<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import TgsqBrowse from "./TgsqBrowse";
import TgsqEdit from "./TgsqEdit";
import TgsqForm from "./TgsqForm";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "Tgsq",
    components: { TgsqBrowse, TgsqEdit, TgsqForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                componentName: "TgsqBrowse",
                submited: false
            }
        };
    },
    created() {
        if (this.getNoticeId) {
            this.editProps.componentName = "TgsqEdit";
        }
    },
    computed: {
        ...userMapGetters(["getNoticeId"]),
        compName() {
            return this.editProps.componentName;
        }
    }
};
</script>
